<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<!-- <div class="mb-3px">
  <div class="col wccard">
    <div class="row mt-3">
      <div class="d-inline-flex col">
        <div class="w-100 d-flex align-items-center pointer">
          <p class="f-14 text-black  font-weight-600"> {{talentpooldetails.name}}</p>
          <p class="f-18 text-black  font-weight-500" *ngIf="!talentpoolview"> All Candidates
            ({{candidateTotalCount}}) </p>


        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="">
  <div class="col-12 wccard p-2 position-relative">
    <div class="d-flex justify-content-between mb-1 mt-1">
      <div class="d-flex">
        <i class="fas fa-arrow-left mr-3 mt-1 pointer" (click)="previewtalentpoollist()"> </i>
        <span class="f-14 mt-3px font-weight-600 d-flex justify-content-between pointer"> {{talentpooldetails?.name | titlecase }}
        </span>
        <div class="position-absolute" style="right: 0px;" *ngIf="talentpooldetails">
          <div class="d-flex align-items-center ">
            <span class="f-14" *ngIf="showfilterCandidatedCount">
             Candidates Found - <span class="f-16 font-weight-600">{{profileCount}}</span>
            </span>
            <span *ngIf="!showfilterCandidatedCount">
            <i class="fa-light fa-users f-14 gray-text"></i>&nbsp;&nbsp; <span class="f-16 font-weight-600">{{talentpooldetails?.candidatecount}}</span>
            </span>
            <!-- <span *ngIf="!isSharedTalentpool" class="ml-2 ats-cta-btn"> <i class="fas fa-edit f-12" (click)="editTalentpoolDetails()"></i>
            </span> -->
            <span *ngIf="isSharedTalentpool">&nbsp;&nbsp;&nbsp;</span>
            <div *ngIf="!isSharedTalentpool" class="ats-dropBtn mx-1 ml-2" ngbDropdown placement="bottom-end" container="body">
              <button data-testid="auto-app-talentpool-details-button-1" class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton"
                ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="userDropdownButton">
                <!-- sharing current talentpool -->
                 <button data-testid="auto-app-talentpool-details-button-2" type="button" class="dropdown-item f-14" (click)="editTalentpoolDetails()" ngbDropdownItem>
                  <span>
                    <i class="fas fa-edit mr-1 text-webbtree-green"></i>
                    Edit talentpool
                  </span>
                </button>
                <button data-testid="auto-app-talentpool-details-button-3" type="button" class="dropdown-item f-14" (click)="triggerTalentpoolSharing()" ngbDropdownItem>
                  <span>
                    <i class="fa-solid fa-share-nodes mr-1 text-webbtree-green"></i>
                    Share talentpool
                  </span>
                </button>
                <button data-testid="auto-app-talentpool-details-button-4" type="button" class="dropdown-item f-14" (click)="deleteTalentpoolConfirmation(talentpooldetails)" ngbDropdownItem>
                  <span>
                    <i class="fa-solid fa-trash mr-1 text-webbtree-green"></i>
                    Delete talentpool
                  </span>
                </button>
              </div>
            </div>
          </div>
       </div>
       </div>
    </div>
    <div class="d-flex justify-content-between ml-5">
      <div class="f-12 text-9696 line-height-1">{{talentpooldetails?.description}}</div>
    </div>
    <div class="" *ngIf="talentpooldetails">
      <div class="col d-flex align-items-center mt-2">
        <div class="text-9696 f-12 d-flex ml-auto"><i class="far fa-user"></i><span class="ml-2">{{talentpooldetails?.firstname}} {{talentpooldetails?.lastname}}</span>
          <i class="fas fa-circle mt-1 ml-2" style="font-size: 6px;"></i> <span class="ml-2 f-12">{{talentpooldetails?.createdon | date:'dd MMM yyyy'}}</span>
        </div>

      </div>
    </div>


  </div>
</div>
<div class="">
 <app-candidate-list (talenpoolrefreshEvent)="gettalentpoolcounts($event)" (candidateCount)="getCandidateCountAfterFiller($event)" *ngIf="talentpooldetails" [talentpoolDetails]="talentpooldetails"></app-candidate-list>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ng-template #deleteTalentpoolmodal>
  <div class="modal-header b pb-0">
    <h5 class="modal-title" id="experience"></h5>
    <button data-testid="auto-app-talentpool-details-button-5" type="button" class="close font-weight-normal ms-auto btn p-0 f-20" data-dismiss="modal" aria-label="Close"
      (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pb-6">
    <div class="row mb-6">
      <div class="col text-center">
        <p>Are you sure you want to delete this Talentpool?
        <p>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-10 mx-auto d-flex">
        <button data-testid="auto-app-talentpool-details-button-6" class="btn-trms-white mx-auto" (click)="modalService.dismissAll()">NO</button>
        <button data-testid="auto-app-talentpool-details-button-7" class="btn-trms-small m-auto" (click)="deleteTalentpool()">YES</button>
      </div>
    </div>
  </div>
</ng-template>
